import * as hpServicesApi from "../../api/healthPlanServicesApi";
import * as types from "../../constants/actionTypes";
import { call, put, select } from "redux-saga/effects";
import { logAPI } from "../../api/andyliticsApi";

export function* getUsage(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = params.memberId;
    let asOfDate = params.asOfDate || new Date();
    let includeAll = params.includeAll || false;

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData.t && memberId) {//Bug-34585
                const response = yield call(hpServicesApi.BenefitsApi.getAccumulators, domainData.t, memberId, asOfDate, includeAll); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetUsage", start, null);
                yield put({ type: types.HP_GET_ACCUMULATOR_DATA_SUCCESS, usage: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetUsage.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_ACCUMULATOR_DATA_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetUsage.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getServiceCategories(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = params.memberId || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;
    let asOfDate = params.asOfDate || new Date();
    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData.t && memberId) {//Bug-34585
                const response = yield call(hpServicesApi.BenefitsApi.getServiceCategories, domainData.t, memberId, asOfDate); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetServiceCategories", start, null);
                yield put({ type: types.HP_GET_SERVICE_CATEGORIES_SUCCESS, serviceCategories: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetServiceCategories.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_SERVICE_CATEGORIES_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetServiceCategories.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getBenefitPlans(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    let memberId = params.memberId || sessionData.healthPlanUserProfile.memberUserClaims.memberHccId;

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData.t && memberId) {//Bug-34585
                const response = yield call(hpServicesApi.BenefitsApi.getBenefitPlans, domainData.t, memberId); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitPlans", start, null);
                yield put({ type: types.HP_GET_BENEFIT_PLANS_SUCCESS, benefitPlans: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.HP_GET_BENEFIT_PLANS_FAILURE, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitPlans.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_BENEFIT_PLANS_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetBenefitPlans.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getBenefitPlanDetail(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.BenefitsApi.getPlanDetails, domainData.t, params.memId); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetPlanDetail", start, null);
                yield put({ type: types.HP_GET_BENEFIT_PLAN_DETAIL_SUCCESS, planDetail: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetPlanDetail.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_BENEFIT_PLAN_DETAIL_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetPlanDetail.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}

export function* getIsMemberDPCFlag(params) {
    const start = new Date();
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);

    if (stateData && stateData.aalDown === false) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(hpServicesApi.BenefitsApi.getIsMemberDPCFlag, domainData.t, params.memberId); //t = access token, aai = American Airlines id
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetPlanDetail", start, null);
                yield put({ type: types.HP_GET_IS_MEMBER_DPC_SUCCESS, isMemberDPC: response, isFetching: false });
            }
        }
        catch (response) {
            console.error(response);
            // Microsoft Edge throws TypeMismatchError when fetch returns 401
            if (response.status === 401 || response.message === 'TypeMismatchError') {
                yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetPlanDetail.Failure", start, null, '401 - login expired or invalid auth token');
            }
            else {
                yield put({ type: types.HP_GET_IS_MEMBER_DPC_FAILURE, error: response });
                logAPI("MBHWeb.Saga.HealthPlanServices.Benefits.GetPlanDetail.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("webTPASaga: aalDown");
    }
}
